/**
 * Pojmenovaný filtr pro proklik z command palette do seznamu entity s předvyplněným fulltextem
 * (DEV-1295). Jde stejnou cestou jako dlaždice na landing page — `set<X>ListState()` pošle
 * `?setFilter=search&q=<dotaz>&resetFilter=true` a effect seznamu si `q` přemapuje na své
 * kritérium fulltextu.
 *
 * Konstanta je tady, aby ji sdílela paleta (features/command-palette) i effecty všech tří seznamů
 * a nerozjela se opisem stringu na čtyřech místech.
 */
export const LIST_SEARCH_FILTER = 'search'

/**
 * Varianta pro seznam smluv, když backend hledal podle **čísla smlouvy**, ne podle jména osoby
 * (rozhoduje `SearchResultDto.contractsMatchedByNumber`). Seznam podle toho předvyplní
 * `contractNumberOfficial` místo `subjectSearchText` — bez toho dotaz „10" najde v paletě smlouvy
 * podle čísla, ale seznam by filtroval podle jména a neukázal nic.
 */
export const LIST_SEARCH_NUMBER_FILTER = 'searchNumber'

/** Query param s hledaným výrazem, který doprovází `setFilter=search`. */
export const LIST_SEARCH_QUERY_PARAM = 'q'